import { get } from 'lodash/fp';

// @ts-expect-error - Automatic, Please fix when editing this file
const getCodeType = (offer) => get('canBeRedeemedWithPromoCode[0].codeType', offer);

export default getCodeType;
